import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Transition" }
const _hoisted_2 = { class: "Transition__Inner section__inner" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "Transition__Background color--1" }, null, -1)
const _hoisted_4 = { class: "Transition__Subinner section__subinner" }
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = { class: "grid" }
const _hoisted_7 = { class: "Transition__Content" }
const _hoisted_8 = { class: "color--2" }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyPicture = _resolveComponent("LazyPicture")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_LazyPicture, {
            class: "picture picture--appear",
            image: _ctx.slide.image,
            alt: _ctx.slide.title
          }, null, 8, ["image", "alt"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.slide.title), 1),
            _createElementVNode("div", {
              class: "Transition__Text color--3",
              innerHTML: _ctx.slide.text
            }, null, 8, _hoisted_9)
          ])
        ])
      ])
    ])
  ]))
}